import { clientLookupCollectionGuard } from './_api/clients';
import { orderCustomerPickupCollectionGuard } from './_api/orders';

export const routeGuard = [
  clientLookupCollectionGuard,
  orderCustomerPickupCollectionGuard,
];
